module.exports = __webpack_public_path__ + "static/media/Abraham Lincoln - 1860.8b1e6105.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/us/Abraham Lincoln - 1860.jpg
// module id = 428
// module chunks = 0